import {useEffect, useCallback, forwardRef} from 'react'

import useGridMinHeight from '../../../../hooks/useGridMinHeight'

import {StaticDatePicker} from '@mui/x-date-pickers'

import FormControl from '@mui/material/FormControl'
import InputLabel from '@mui/material/InputLabel'
import FormHelperText from '@mui/material/FormHelperText'




const StaticDatePickerField = forwardRef(({
  field: { name, value, onBlur },
  form:  { touched, errors, setFieldValue, isSubmitting },
  label,
  helperText,
  minDate,
  maxDate,
  disablePast = true,
  disableFuture = false,
  ...pickerProps
}, ref) => {

  const errorMsg = errors[name]
  const isError  = touched[name] && Boolean(errorMsg)

  const [containerRef, minHeight] = useGridMinHeight({columns: 7, rows: 6, gap: 4})


  // Keep the value at or above minDate
  useEffect(() => {
    if ((value == null || (minDate && +value < +minDate)) && minDate) {
      setFieldValue(name, minDate)
    }
  }, [minDate, value, name, setFieldValue])


  const handleChange = useCallback(newDate => {
    setFieldValue(name, newDate)
  }, [name, setFieldValue])



  return (
    <FormControl error={isError} fullWidth variant='filled'>
      {label && <InputLabel shrink>{label}</InputLabel>}

      <div ref={containerRef} style={{width: '100%'}}>
        <StaticDatePicker
          value={value}
          onChange={handleChange}
          onAccept={handleChange}
          disablePast={disablePast}
          disableFuture={disableFuture}
          minDate={minDate instanceof Date ? minDate : new Date(minDate)}
          maxDate={maxDate instanceof Date ? maxDate : new Date(maxDate)}
          slotProps={{
            actionBar: {
              actions: []
            }
          }}
          sx={{
            minWidth: 0,
            // always hide any scrollbar
            '.MuiPickersSlideTransition-root': {
              overflow: 'visible',
              minHeight: `${Math.min(minHeight ? minHeight : 320, 320)}px`,
            },

            // toolbar & header tweaks
            '.MuiPickersCalendarHeader-root': { 
              paddingLeft: '15px',
              paddingRight: 0
            },
            '.MuiPickersToolbar-root': { 
              padding: 0,
              '& > span': {
                display: 'none'
              }
            },

            '.MuiDateCalendar-root': {
              width: '100%',
              height: 'auto',
              maxHeight: '500px'
            },

            // force the 6‑row grid
            '.MuiDayCalendar-monthContainer': {},

            // week header
            '& .MuiDayCalendar-header': {
              display:             'grid',
              gridTemplateColumns: 'repeat(7,1fr)',
              padding:             '0 4px',
              marginBottom:        '4px',
              '& > span': {
                textAlign:  'center',
                fontSize:   '1rem',
                fontWeight: 800,
              }
            },

            // days cells stay square & fill each slot
            '& .MuiPickersDay-root': {
              aspectRatio:    '1/1',
              width:          '100%',
              height:         'auto',
              maxWidth:       '50px',
              minHeight:      0,
              padding:        0,
              display:        'flex',
              alignItems:     'center',
              justifyContent: 'center',
              fontSize:       '1rem',
            }
          }}
          {...pickerProps}
        />
      </div>

      <FormHelperText>
        {isError ? errorMsg : helperText}
      </FormHelperText>
    </FormControl>
  )
})


export default StaticDatePickerField



